export type CourseColor = {
  foreground: string;
  background: string;
  name: string;
};

export const courseColors: CourseColor[] = [
  // Reds & Pinks
  { foreground: '#3A1519', background: '#FFBBC2', name: 'Coral' },
  { foreground: '#3A1B1B', background: '#FFB3B3', name: 'Rose' },
  { foreground: '#4B1B2E', background: '#FFB3D2', name: 'Petal' },
  { foreground: '#4B1B1B', background: '#FFD6D6', name: 'Blossom' },
  { foreground: '#4B1B1B', background: '#FFB3B9', name: 'Flamingo' },
  { foreground: '#4B1B1B', background: '#FF7043', name: 'Salmon' },
  { foreground: '#3A1B2B', background: '#FF69B4', name: 'Hot Pink' },
  { foreground: '#3A1B2B', background: '#FF00FF', name: 'Magenta' },
  { foreground: '#3A1B2B', background: '#FF85A1', name: 'Bubblegum' },

  // Oranges
  { foreground: '#4B3530', background: '#FFB9AA', name: 'Peach' },
  { foreground: '#4B2E1B', background: '#FFD6B3', name: 'Sand' },
  { foreground: '#4B3A1B', background: '#FFB300', name: 'Amber' },
  { foreground: '#4B3A1B', background: '#FF9800', name: 'Orange' },

  // Yellows
  { foreground: '#534B30', background: '#FFEBA5', name: 'Golden' },
  { foreground: '#4B3A1B', background: '#FFD2B3', name: 'Apricot' },
  { foreground: '#3A2B1B', background: '#FFE0B3', name: 'Cream' },
  { foreground: '#4B3A1B', background: '#FFEDB3', name: 'Sunshine' },
  { foreground: '#4B3A1B', background: '#FFF700', name: 'Lemon' },

  // Greens
  { foreground: '#2B3A1B', background: '#D2FFB3', name: 'Pistachio' },
  { foreground: '#1B3A1B', background: '#B3FFB3', name: 'Spring' },
  { foreground: '#2E4B1B', background: '#D6FFB3', name: 'Lime' },
  { foreground: '#304F31', background: '#C4F9C6', name: 'Mint' },

  // Teals & Cyans
  { foreground: '#1B2E2B', background: '#A7F6D2', name: 'Aqua' },
  { foreground: '#1B3A36', background: '#76E4F7', name: 'Cyan' },
  { foreground: '#1B3A36', background: '#00B8A9', name: 'Teal' },
  { foreground: '#1B3A36', background: '#48C9B0', name: 'Seafoam' },
  { foreground: '#1B3A2F', background: '#B6F0E6', name: 'Turquoise' },
  { foreground: '#1B3A3A', background: '#7FFFD4', name: 'Aquamarine' },
  { foreground: '#1B3A2B', background: '#00CED1', name: 'Dark Turquoise' },
  { foreground: '#1B2B3A', background: '#40E0D0', name: 'Turquoise Blue' },

  // Blues
  { foreground: '#202B3C', background: '#A9CBFF', name: 'Lapis' },
  { foreground: '#3A464D', background: '#C2E8FF', name: 'Sky' },
  { foreground: '#344550', background: '#D3E0EA', name: 'Steel' },
  { foreground: '#1B2B3A', background: '#B3E0FF', name: 'Ice Blue' },
  { foreground: '#1B2B3A', background: '#A3D8F4', name: 'Azure' },

  // Purples & Lavenders (Indigo/Violet)
  { foreground: '#49304E', background: '#F7C6FF', name: 'Fuchsia' },
  { foreground: '#3E3C5E', background: '#C9C6FF', name: 'Lavender' },
  { foreground: '#2E1B3A', background: '#E6B6F0', name: 'Orchid' },
  { foreground: '#3A1B2B', background: '#FFB3E0', name: 'Blush' },
  { foreground: '#3A1B3A', background: '#E0B3FF', name: 'Violet' },
  { foreground: '#3A1B3A', background: '#D291FF', name: 'Amethyst' },
  { foreground: '#3A1B2B', background: '#B388FF', name: 'Mauve' },
];
